import * as React from 'react'
// libs
import { useMutation } from '@apollo/client/react'
import { useDispatch, useSelector } from 'react-redux'
// hooks
import { useShowModal } from 'hooks/useShowModal'
import { useCurrentUser } from 'hooks/useCurrentUser'
// view components
import ResponseTypesSetModal from 'components/Modals/ResponseTypesSetModal'
import ResponseTypesSetsList from './components/OptionsList'
// views
import { AddButton } from 'components/Modals/PropertyDetailsModal/components/Form/view'
import { Label, ResponseSetContainer } from './views'
// graphql
import { COMPANY_RISK_RESPONSE_TYPES_QUERY } from 'graphql/company/queries'
import { COMPANY_UPDATE_RISK_RESPONSE_MUTATION } from 'graphql/company/mutations'
// types
import { Modals } from 'constants/index'
// store
import { responseTypesSelector, setResponseTypes } from 'store/reducers/riskTemplates'

const ResponseTypesSets: React.FC = () => {
  const user = useCurrentUser()
  const dispatch = useDispatch()

  const [updateRiskResponse] = useMutation(COMPANY_UPDATE_RISK_RESPONSE_MUTATION, {
    refetchQueries: [COMPANY_RISK_RESPONSE_TYPES_QUERY]
  })

  const { showModal } = useShowModal({ modalType: Modals.RESPONSE_TYPES_SET_MODAL })

  const responseTypeSets = useSelector(responseTypesSelector)

  const removeOption = (id: string) => async () => {
    const input = responseTypeSets.filter((data) => data.id !== id)

    await updateRiskResponse({
      variables: {
        id: user.company.id,
        input: {
          responseTypesSets: input
        }
      }
    })

    dispatch(setResponseTypes(input))
  }

  const addField = () => showModal()

  return (
    <div>
      <Label>Multiple choice responses</Label>
      <ResponseSetContainer>
        {responseTypeSets.map((data, idx) => (
          <ResponseTypesSetsList key={data.id} idx={idx} data={data} removeOption={removeOption(data.id)} />
        ))}
      </ResponseSetContainer>
      <AddButton onClick={addField}>+ add response</AddButton>
      <ResponseTypesSetModal responseTypeSets={responseTypeSets} />
    </div>
  )
}

export default ResponseTypesSets
